import React from "react";
import styled from "styled-components";
import webdevelopment from "../Assets/Azharpic3.jpg";
const PageWrapper = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;

  @media (max-width: 1024px) {
    max-width: 90%;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    max-width: 95%;
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    text-align: center;
    line-height: 1.6;
  }
`;
const MobileAppImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  margin-bottom: 20px;
  @media (max-width: 600px) {
    width: 100%;
    height: 220px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: 320px;
  }
`;
const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;
const Wrap = styled.div`
  padding: 0;
  margin: 0;
  background-color: #f9f9f9;
  width: 100%;
  height: 100%;
  // padding: 20px 0;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;
export default function PrivacyPolicy() {
  return (
    <Wrap>
      <MobileAppImage src={webdevelopment} alt="Background" />
      <PageWrapper>
        <Title>Privacy Policy</Title>
        <p>
          At <b>AttractDeals</b>, we respect your privacy and are committed to
          protecting the personal information you share with us. This policy
          explains how we collect, use, and safeguard your data.
        </p>
        <p>
          <b>Information We Collect:</b> We may collect non-personal data such
          as browser type, device, and usage details to improve your experience.
        </p>
        <p>
          <b>Cookies:</b> We use cookies and affiliate tracking codes to ensure
          proper functioning of the Amazon Associates Program.
        </p>
        <p>
          <b>Third-Party Links:</b> Our website contains links to Amazon. When
          you click and purchase, Amazon’s privacy policies apply.
        </p>
        <p>
          <b>Consent:</b> By using our site, you consent to this Privacy Policy.
        </p>
      </PageWrapper>
    </Wrap>
  );
}
